import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class ProvidersService {

  // Get providers list
  getProviders = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc') => {
    return await axios.get(API_URL + '/providers?page=' + pageNum + '&search=' + search + '&limit=' + limit + '&sortBy=' + sortBy + '&sortOrder=' + sortOrder, { headers: authHeader() })
  }

  // Add new provider
  addProvider = async (provider) => {
    return await axios.post(API_URL + '/providers', provider, { headers: authHeader() })
  }

  // Update provider data
  updateProvider = async (provider, id) => {
    return await axios.patch(API_URL + '/providers/' + id, provider, { headers: authHeader() })
  }

  // Get provider data
  getProvider = async (id) => {
    return await axios.get(API_URL + '/providers/' + id, { headers: authHeader() })
  }

  // Delete provider
  deleteProvider = async (id) => {
    return await axios.delete(API_URL + '/providers/' + id, { headers: authHeader() })
  }

}

export default new ProvidersService()